import StageCard from "../../ProgressStep/StageCard";
import { Button } from "antd";
import React from "react";
import styles from "./style.module.scss";
import AddIcon from "assets/icons/AddIcon";

interface AddClassCardProps {
  onClick: () => void;
}

export default function AddClassCard({ onClick }: AddClassCardProps) {
  return (
    <StageCard
      content={
        <div>
          <div className={styles.titleContainer}>
            <div className={styles.title}>Choose Classes</div>
            <div className={styles.subTitle}>
              Define the initial categories for label propagation
            </div>
          </div>
          <Button className={styles.addClassButton} onClick={onClick}>
            <AddIcon />
          </Button>
        </div>
      }
    />
  );
}
